import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import { useAuthState } from 'src/shared/features/auth/api/use-auth-state'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

export const getNotificationCount = async () => {
  const response = await getRequest<number>(`/feeds/notifications/unread-count`)
  if (typeof response !== 'number') {
    throw new Error('Failed to get notification count')
  }
  return response
}

export const useGetNotificationCount = () => {
  const { currentAuth } = useAuthState()
  const { data: currentUser } = useMyUserData()

  return useQuery({
    ...queries.notifications.count,
    queryFn: getNotificationCount,
    enabled: !!currentAuth && !!currentUser,
    staleTime: 1000 * 60,
  })
}
